import React from 'react';
import { Redirect } from 'react-router-dom';

import { BASE_URL } from 'config';

export const NoMatchPage = () => <Redirect to={BASE_URL} />;
